/* globals Power0 */

// setup the ticker
var tickerSpeed = 30;
var tickerSpeedPixel = tickerSpeed / $(window).width();
var tickerTimelines = [];
var currentTicker = 0;
// var tickerCount = 1;
var force3D = true;

// setup the message
function initilizeTickerMessage(message) {
    message.addClass('initilized');
    TweenMax.set(message, {
        x: $(window).width()
    });

    var tickerMessage = new TimelineMax({
        paused: true
    });
    tickerMessage.to(message, message.outerWidth() * tickerSpeedPixel, {
        x: '-=' + message.outerWidth(),
        force3D: force3D,
        ease: Power0.easeNone,
        onComplete: function () {
            nextTickerMessage();
        }
    });
    tickerMessage.to(message, tickerSpeed, {
        x: '-=' + $(window).width(),
        force3D: force3D,
        ease: Power0.easeNone,
        onComplete: function () {
            markViewed(message);
            tickerMessage.seek(0);
            tickerMessage.pause();
            TweenMax.set(message, {
                // autoAlpha: 0
                x: $(window).width()
            });
            // remvoe the message
            // message.remove();
        }
    });
    tickerTimelines.push(tickerMessage);
}

// add ticker message
function addTickerMessage(message, donation, viewed) {
    var tickerMessage = $('<div />', {
        'class': 'ticker-message',
        'data-viewed': viewed,
        'data-donation': donation,
        html: message
    });

    if ($('.ticker-messages .initilized').length) {
        $('.ticker-messages .initilized').last().after(tickerMessage);
    } else {
        $('.ticker-messages').append(tickerMessage);
    }
    initilizeTickerMessage(tickerMessage);
}

// setup each message
$('.ticker-message').each(function () {
    initilizeTickerMessage($(this));
    // tickerCount++;
});

// play the first ticker
if (tickerTimelines[0]) {
    // tickerTimelines[0].play();
}

function nextTickerMessage() {
    currentTicker++;
    if (!tickerTimelines[currentTicker]) {
        currentTicker = 0;
    }
    tickerTimelines[currentTicker].play();
}

function markViewed(message) {
    message.attr('data-viewed', '1');
    return false;
}



channel.bind('add-tick', function (data) {
    if ($('.ticker').length) {
        addTickerMessage(data.message, data.donation, data.viewed);
    }
});